module.exports = __webpack_public_path__ + "assets/bitong.fc3d5c7a.svg";